// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/route-guards/auth.guard';
import { CustomerGuard } from './services/route-guards/customer.guard';
import { LoginComponent } from './login/login.component';
import { PddjComponent } from './pddj/pddj.component';
import { SystemDocumentComponent } from './login/system-document/system-document.component';
import { SystemDocumentsResolver } from '@services/resolvers/system-documents.resolver';
import { UserResolver } from '@services/resolvers/user.resolver';
import { BuyerDashboardComponent } from './buyer-dashboard/buyer-dashboard/buyer-dashboard.component';
import { DealerDashboardComponent } from './dealer-dashboard/dealer-dashboard/dealer-dashboard.component';
import { DealershipResolver } from '@services/resolvers/dealership.resolver';
import { PDDJResolver } from '@services/resolvers/get-pddj.resolver';
import { NewUserGuard } from '@services/route-guards/new-user.guard';
import { SystemDocsToSignGuard } from '@services/route-guards/system-docs-to-sign.guard';
import { SystemDocsPageGuard } from '@services/route-guards/system-docs-page.guard';
import { DealerGuard } from '@services/route-guards/dealer.guard';
import { VersionNumberResolver } from '@services/resolvers/version-number.resolver';
import { UploadDashboardComponent } from './doc-upload/upload-dashboard/upload-dashboard.component';
import { AgreementsComponent } from './agreements/agreements.component';

const routes: Routes = [
    {
        path: '',
        component: LoginComponent,
    },
    {
        path: 'dashboard',
        component: DealerDashboardComponent,
        canActivate: [AuthGuard, DealerGuard, SystemDocsToSignGuard],
        loadChildren: () => import('./dealer-dashboard/dealer-dashboard-routing.module').then((m) => m.DealerDashboardRoutingModule),
        resolve: {
            pddj: PDDJResolver,
            dealership: DealershipResolver,
            version: VersionNumberResolver,
        },
    },
    {
        path: 'main',
        component: BuyerDashboardComponent,
        canActivate: [AuthGuard, CustomerGuard, SystemDocsToSignGuard],
        resolve: {
            user: UserResolver,
            version: VersionNumberResolver,
        },
        loadChildren: () => import('./buyer-dashboard/buyer-dashboard-routing.module').then((m) => m.BuyerDashboardRoutingModule),
    },
    {
        path: 'login',
        component: LoginComponent,
        loadChildren: () => import('./login/login-routing.module').then((m) => m.LoginRoutingModule),
        resolve: {
            version: VersionNumberResolver,
        },
    },
    {
        path: 'pddj',
        component: PddjComponent,
        loadChildren: () => import('./pddj/pddj-routing.module').then((m) => m.PddjRoutingModule),
        data: {
            title: 'Print to DDJ',
        },
        resolve: {
            dealership: DealershipResolver,
            // version: VersionNumberResolver,
            //user: UserResolver,
        },
    },
    {
        path: 'welcome',
        canActivate: [AuthGuard, NewUserGuard],
        loadChildren: () => import('./new-user/new-user-routing.module').then((m) => m.NewUserRoutingModule),
    },
    {
        path: 'systemDocument',
        canActivate: [AuthGuard, SystemDocsPageGuard],
        component: SystemDocumentComponent,
        resolve: {
            systemDocs: SystemDocumentsResolver,
            user: UserResolver,
        },
    },
    {
        path: 'agreements/:agreement',
        component: AgreementsComponent,
    },
    {
        path: 'sso',
        loadChildren: () => import('./sso/sso-routing.module').then((m) => m.SsoRoutingModule),
    },
    {
        path: 'upload',
        component: UploadDashboardComponent,
        loadChildren: () => import('./doc-upload/upload-routing.module').then((m) => m.UploadRoutingModule),
    },
    {
        path: '**',
        redirectTo: '/',
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { enableTracing: false })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
